import Button from "components/base/Button";
import PriceView from "components/base/PriceView";
import { Alert } from "components/base/Toast";
import SortItemsView from "components/shared/SortComponentsView";
import { CurrencyContext } from "CurrencyProvider";
import { useModals } from "ModalProvider";
import { useContext } from "react";
import { computeCost } from "utils/cost";

const ProductPackagingOptionView = ({
  index,
  components,
  packagingInfo,
  editPackaging,
  incNumber,
  highestCost,
  onChange,
}) => {
  const { usdExchangeRates } = useContext(CurrencyContext);

  const computedComponents = packagingInfo.components
    .map((i) => ({
      ...i,
      product: components.find((c) => c.id === i.id),
    }))
    .filter((i) => i.selected && i.product);

  const componentsForCost = computedComponents.map((i) => ({
    ...i,
    prices: i.product.prices,
  }));

  const { totalCost, costPerUnit, usedPrice, cnyExchangeRate } = computeCost(
    packagingInfo.orderQty,
    packagingInfo.bomQty,
    componentsForCost,
    usdExchangeRates,
    "USD",
  );

  console.log("packagingInfo", packagingInfo);

  const modal = useModals();

  function sortComponents() {
    modal.present({
      title: "Sort Components",
      children: (
        <SortItemsView
          originalItems={packagingInfo.components.filter((i) => i.selected)}
          onSave={(newComponents) => {
            Alert("success", "Components sorted.");
            onChange({ components: newComponents });
            modal.hide();
          }}
          rowView={(i) => (
            <div className="">
              {i.type === "Product" ? "⚽️" : "📦"} {i.name}
            </div>
          )}
        />
      ),
    });
  }

  return (
    <div>
      <div className="flex justify-between items-end">
        <div>
          <h5>Packaging Option #{index + 1}</h5>
          <div>
            {packagingInfo.packagingType}, {packagingInfo.bomQty} / Outer Carton
          </div>
        </div>
        <div className="flex space-x-3">
          <Button onClick={sortComponents}>↕ Sort</Button>
          <Button onClick={() => editPackaging(packagingInfo)}>Edit</Button>
        </div>
      </div>
      <div className="mt-2 -mx-2">
        <table>
          <tbody>
            {computedComponents.map((comp, compIndex) => (
              <tr
                key={compIndex}
                className={`border-y border-gray-100 dark:border-gray-700
                  ${!usedPrice[compIndex] && "bg-red-100 dark:bg-red-700"}
                  `}
              >
                <td>
                  #{compIndex + 1}.{" "}
                  {comp.product.type === "Product" ? "⚽️" : "📦"}{" "}
                  {comp.product.name}
                </td>
                <td className="text-right">
                  {usedPrice[compIndex] ? (
                    <PriceView
                      currency={usedPrice[compIndex].currency}
                      price={usedPrice[compIndex].price}
                      targetCurrency="USD"
                      exchangeRate={cnyExchangeRate}
                    />
                  ) : (
                    <span className="font-semibold text-red-500">
                      No price found for the qty:{" "}
                      {(comp.qty * packagingInfo.orderQty) /
                        packagingInfo.bomQty}
                    </span>
                  )}
                </td>

                <td className="text-right">&times; {comp.qty}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="mt-4 flex justify-between space-x-4">
        <div>
          <div className="flex items-center space-x-2">
            <label>For Order Quantity: {packagingInfo.orderQty}</label>
            <span>
              ({packagingInfo.orderQty / packagingInfo.bomQty} cartons, exchange
              rate: {cnyExchangeRate}, total USD {totalCost.toFixed(3)} /{" "}
              {packagingInfo.orderQty})
            </span>
          </div>
          <div className="opacity-70 text-xs">
            Different order qty will have different cost if we have components
            with tiered pricing.
          </div>
        </div>

        <div className="text-right">
          <div>
            <label>Unit Cost: </label>
            <b>
              USD {costPerUnit.toFixed(3)}
              {highestCost !== undefined && (
                <>
                  (
                  <b
                    className={
                      costPerUnit > highestCost
                        ? "text-red-500"
                        : "text-green-500"
                    }
                  >
                    {(costPerUnit - highestCost).toFixed(3)}
                  </b>
                  )
                </>
              )}
            </b>
          </div>

          {incNumber && (
            <div className="whitespace-nowrap">
              <label>Price for INC (cost/{incNumber}): </label>
              <b>USD {(costPerUnit / incNumber).toFixed(3)}</b>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProductPackagingOptionView;
